import { jsx as r, Fragment as S, jsxs as l } from "react/jsx-runtime";
import { Transition as j } from "@headlessui/react";
import { ChevronUpDownIcon as L, CheckIcon as R } from "@heroicons/react/24/outline/index.js";
import { classNames as n } from "../../../Utils/classNames.js";
import { isDefined as T } from "../../../DataUtils/isDefined.js";
import { useState as v, useRef as x } from "react";
import { XCircleIcon as D } from "@heroicons/react/24/outline";
import { useCloseOnClickOutside as O } from "../Hooks/useCloseOnClickOutside.js";
function E({
  options: c,
  value: a,
  onChange: u,
  placeholder: d,
  errorMessage: s,
  disabled: t,
  clearable: m,
  hasError: y,
  searchable: i,
  testId: N
}) {
  const o = T(a) ? c.find((e) => e.id === a) : void 0, [k, f] = v(!1), [p, C] = v(""), h = x(null), g = x(null), { isOpen: w, setIsOpen: b } = O(
    h.current,
    g.current
  );
  function F() {
    return o != null && o.name ? o == null ? void 0 : o.name : d ?? "";
  }
  return /* @__PURE__ */ r(S, { children: /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { children: [
      /* @__PURE__ */ l(
        "div",
        {
          "data-testid": N,
          className: n(
            "relative flex items-center",
            t ? "cursor-not-allowed" : "cursor-pointer"
          ),
          children: [
            /* @__PURE__ */ r(
              "input",
              {
                readOnly: !i,
                placeholder: d,
                onFocus: () => f(!0),
                onBlur: () => f(!1),
                ref: h,
                onClick: () => {
                  t || b((e) => !e);
                },
                onChange: (e) => {
                  i && C(e.target.value ?? "");
                },
                value: i && k && w ? p : F(),
                className: n(
                  "border text-sm rounded-lg block w-full pt-2.5 pb-2.5 pl-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white",
                  s || y ? "border-red-500 focus:ring-red-500" : "dark:focus:border-blue-500 focus:border-blue-500 dark:border-gray-600 focus:ring-blue-500 dark:focus:ring-blue-500 border-slate-200",
                  m ? "pr-14" : "pr-10",
                  t ? "bg-slate-100 cursor-not-allowed focus:outline-none focus:border-slate-200" : "cursor-pointer bg-white"
                )
              }
            ),
            /* @__PURE__ */ r(
              L,
              {
                className: "absolute right-4 w-5 text-slate-500"
              }
            ),
            m ? /* @__PURE__ */ r(
              "span",
              {
                className: n(
                  "absolute inset-y-0 right-7 flex items-center pr-2",
                  t ? "" : "cursor-pointer"
                ),
                children: /* @__PURE__ */ r(
                  D,
                  {
                    onClick: (e) => {
                      t || (e.stopPropagation(), u(null));
                    },
                    className: n(
                      "h-5 w-5 text-gray-400",
                      t ? "" : "hover:text-gray-700"
                    ),
                    "aria-hidden": "true"
                  }
                )
              }
            ) : null
          ]
        }
      ),
      s ? /* @__PURE__ */ r("p", { className: "text-md mt-2 text-red-500", children: s }) : null
    ] }),
    /* @__PURE__ */ r("div", { className: "relative w-full", children: /* @__PURE__ */ r(
      j,
      {
        enter: "transition-opacity duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        show: w,
        children: /* @__PURE__ */ r(
          "div",
          {
            ref: g,
            className: "bg-white z-10 absolute w-full rounded-lg shadow-xl shadow-slate-200/40 overflow-hidden overflow-y-auto max-h-[300px]",
            children: c.filter(
              (e) => i ? e.name.toLowerCase().includes(p.toLowerCase()) : !0
            ).map((e) => {
              const I = a === e.id;
              return /* @__PURE__ */ l(
                "div",
                {
                  onClick: () => {
                    u(e.id), b(!1);
                  },
                  className: n(
                    "flex items-center justify-between pl-2.5 pt-2.5 pb-2.5 border-b border-gray-100 pr-10",
                    "cursor-pointer hover:bg-primary hover:text-white"
                  ),
                  children: [
                    /* @__PURE__ */ r("div", { className: "", children: /* @__PURE__ */ r("p", { className: "", children: e.name }) }),
                    I ? /* @__PURE__ */ r(R, { className: "absolute right-4 w-5" }) : null
                  ]
                },
                e.id
              );
            })
          }
        )
      }
    ) })
  ] }) });
}
export {
  E as Select
};
//# sourceMappingURL=Select.js.map
